import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared-module';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'app-anchor',
  templateUrl: './anchor.component.html',
  styleUrl: './anchor.component.scss',
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnchorComponent {
  @Input() to = '';
  @Input() text = '';
  @Input() preventIf = false;
  @Output() onClick = new EventEmitter();
  constructor(public i18nService: I18nService) {}
}
